// import external modules
import React, { PureComponent } from 'react';
import { Link, withRouter } from 'react-router-dom';
import TopLevelNavLink2 from '../components/nav/topLevelNavLink2';
import SourcedVenue from '../views/sourced-venues/sourcedVenue';
import SystemToolbar from '../components/nav/systemToolbar';
import LoadingWizard from '../components/spinner/wizard';
import API from '../utils/API';

class SourcedVenueLevelLayout extends PureComponent {
	constructor(props) {
		super(props);

		let manageNavigation = [
			{
				name: 'Venue Info',
				icon: <i className="las la-building" />,
				section: 'info'
			},
			{
				name: 'Event Details',
				icon: <i className="las la-calendar-alt" />,
				section: 'event-details'
			},
			{
				name: 'Room Blocks',
				icon: <i className="las la-bed" />,
				section: 'room-blocks'
			},
			{
				name: 'Meeting Spaces',
				icon: <i className="las la-couch" />,
				section: 'meeting-spaces'
			},
			{
				name: 'Additional Info',
				icon: <i className="las la-list-ul" />,
				section: 'additional-info'
			},
			{
				name: 'Concessions',
				icon: <i className="las la-handshake" />,
				section: 'concessions'
			},
			{
				name: 'Planner Info',
				icon: <i className="las la-user-tie" />,
				section: 'planner-info'
			},
			{
				name: 'Agency Info',
				icon: <i className="las la-building" />,
				section: 'agency-info'
			},
			{
				name: 'RFP Status',
				icon: <i className="las la-tasks" />,
				section: 'rfp-status'
			}
		];

		this.state = {
			orgId: this.props.match.params.organization,
			venueId: this.props.match.params.venue,
			manageNavigation: manageNavigation,
			venue: {},
			loading: true
		};
	}

	async componentDidMount() {
		const venueId = this.state.venueId;
		const { orgId } = this.props;
		try {
			const venue = await API().get(`Organizations/${orgId}/sourced-venues/${venueId}`).then();
			
			// Update counts for navigation
			const { manageNavigation } = this.state;
			manageNavigation.forEach((navItem) => {
				if (navItem.section === 'meeting-spaces') {
					navItem.count = venue.data.meetingSpaces?.length || 0;
				} else if (navItem.section === 'room-blocks') {
					navItem.count = venue.data.roomBlock?.dailyGrid?.length || 0;
				} else if (navItem.section === 'concessions') {
					navItem.count = venue.data.concessions?.length || 0;
				}
			});

			this.setState({ manageNavigation, loading: false, venue: venue.data });
		} catch (e) {
			console.log(e);
			this.setState({ loading: false });
		}
	}

	refreshSectionCounts = async () => {
		const venueId = this.state.venueId;
		const { orgId } = this.props;
		try {
			const venue = await API().get(`Organizations/${orgId}/sourced-venues/${venueId}`).then();
			
			let { manageNavigation } = this.state;
			manageNavigation = manageNavigation.map((navItem) => {
				if (navItem.section === 'meeting-spaces') {
					navItem.count = venue.data.meetingSpaces?.length || 0;
				} else if (navItem.section === 'room-blocks') {
					navItem.count = venue.data.roomBlock?.dailyGrid?.length || 0;
				} else if (navItem.section === 'concessions') {
					navItem.count = venue.data.concessions?.length || 0;
				}
				return navItem;
			});

			this.setState({ manageNavigation, venue: venue.data });
		} catch (e) {
			console.log(e);
		}
	};

	render() {
		const { organizations, permission, subscriptionAddons, subscriptionType, organization, socket } = this.props;
		const { orgId, venueId, loading, manageNavigation, venue } = this.state;

		return (
			<div className="application">
				<div className="topLevelPages ">
					<div className={`systemContentContainer`}>
						<SystemToolbar
							socket={socket}
							markNotificationAsRead={this.props.markNotificationAsRead}
							platformNotifications={this.props.platformNotifications}
							permission={this.props.permission}
							account={this.props.account}
							organization={organization}
							organizations={organizations}
							logout={this.props.logout}
							programsAvailable={this.props.programsAvailable}
							subscriptionAddons={this.props.subscriptionAddons}
							subscriptionType={this.props.subscriptionType}
							displayLogo={true}
							taskCount={this.props.taskCount}
							updateTaskCount={this.props.updateTaskCount}
							pingServer={this.props.pingServer}
						/>
						<div className="flex" style={{ height: 'calc(100% - 55px)' }}>
							<div className={`sideNavigation ${loading ? 'closed' : ''}`}>
								<div className="sideMenuContainer overview">
									<Link to={`/${orgId}/venues/${venueId}/`} className="menutItemLink">
										<div className="p-30 pt-15 pb-0 pr-20 pb-20 ">
											<h3 className="sideEventName">{venue.name || 'Venue'}</h3>
											<p className="small">{venue.location || 'Location not set'}</p>
										</div>
										<i className="las la-angle-right" />
									</Link>
									<hr className="m-20 mt-0 mr-0 ml-0" />
									<div className="scrollContainer">
										{manageNavigation.length > 0 && <h5 className="mb-10 sideNaveColor">Proposal</h5>}
										{manageNavigation.map((menuItem, index) => {
											return (
												<TopLevelNavLink2
													isLast={index === manageNavigation.length - 1}
													orgId={orgId}
													menuItem={menuItem}
													prefix={`/${orgId}/venues/${venueId}`}
													index={index}
													permission={permission}
													loading={loading}
													key={`venue-manage-nav-${index}`}
													id={menuItem.section}
												/>
											);
										})}
									</div>
								</div>
							</div>
							{!loading && (
								<SourcedVenue
									{...this.props}
									venue={venue}
									refreshSectionCounts={this.refreshSectionCounts}
								/>
							)}
							{loading && (
								<div className="pageContainer">
									<LoadingWizard text="LOADING VENUE" loading={loading} />
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default withRouter(SourcedVenueLevelLayout);
